import { render } from "./question6.vue?vue&type=template&id=7a53a9c0&scoped=true"
import script from "./question6.vue?vue&type=script&lang=js"
export * from "./question6.vue?vue&type=script&lang=js"

import "./question6.vue?vue&type=style&index=0&id=7a53a9c0&scoped=true&lang=css"

import exportComponent from "/Users/atomu/Desktop/GitHub/good_neet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a53a9c0"]])

export default __exports__